import '../../sass/pages/_notFound.scss'

// Import components
import SplitText from "../components/SplitText"

document.addEventListener('DOMContentLoaded', (event: any) => {
    NotFound()
})

const NotFound = () => {
    setSplitText()
}

const setSplitText = () => {
    new SplitText('.title')
    new SplitText('.subtitleSmall')
}